import { businessDateOfTimestamp } from '../dates/business-day.js';
import { addDays } from '../dates/calendar-date.js';
/**
 * Delivered date + net days, as a Pacific business date. Null net days (Consignment) is due on
 * receipt, like COD (NUDOOL-24 decision #9).
 */
export function arDueDate({ deliveredAt, netDays, }) {
    return addDays(businessDateOfTimestamp(deliveredAt), netDays ?? 0);
}
//# sourceMappingURL=ar-due-date.js.map